<template>
  <cockpit-dialog
    title="缺陷趋势"
    width="1600px"
    height="800px"
    top="120px"
    left="160px"
    cardType="horizontal"
    @close="closeDialog"
  >
    <v-chart
      class="w-full h-full"
      :options="chartOptions"
      :autoresize="true"
      :init-options="{ devicePixelRatio: 2 }"
    ></v-chart>
  </cockpit-dialog>
</template>

<script>
import CockpitDialog from '@/components/cockpit/CockpitDialog'

export default {
  components: { CockpitDialog },
  data() {
    return {
      chartOptions: {
        animation: false,
        color: [
          '#3CD495',
          '#5FD5EC',
          '#2276FC',
          '#3f51b5',
          '#e51c23',
          '#009688',
          '#259b24',
          '#ff9800',
          '#8129bd',
          '#b5c334',
          '#fcce10',
          '#e87c25',
          '#27727b',
        ],
        tooltip: {
          trigger: 'axis',
          textStyle: { fontSize: 12 },
          confine: true,
          borderWidth: 1,
          borderColor: '#35d0dd',
          backgroundColor: 'rgba(17,83,71,0.8)',
          formatter: (params) => {
            let formatStr = `${this.dayjs(params[0].data[0]).format('YYYY-MM-DD HH:mm:ss')}<br/>`
            _.forEach(params, (item) => {
              formatStr = `${formatStr}${item.marker}${item.seriesName}: ${item.data[1] ||
                '--'}<br/>`
            })
            return formatStr
          },
        },
        legend: {
          data: [],
          type: 'scroll',
          textStyle: {
            color: '#fff',
          },
        },
        grid: {
          top: '15%',
          left: '3%',
          right: '25',
          bottom: '10%',
          containLabel: true,
        },
        xAxis: {
          type: 'time',
          splitLine: { show: false },
          axisLabel: {
            color: '#fff9',
            fontSize: 12,
            showMinLabel: true,
            showMaxLabel: true,
            formatter: (value) => {
              return this.dayjs(value).format('HH:mm:ss')
            },
          },
          axisTick: { show: false },
          axisLine: { lineStyle: { color: '#ffffff4d', fontSize: 12 } },
        },
        yAxis: {
          type: 'value',
          splitArea: { show: false },
          splitLine: { lineStyle: { color: ['rgba(255,255,255,0.05)'], type: 'dashed' } },
          axisTick: { show: false },
          axisLabel: { color: '#fff9', fontSize: 12 },
          axisLine: { show: false, lineStyle: { color: '#ffffff4d' } },
        },
        series: [],
      },
    }
  },
  methods: {
    closeDialog() {
      this.$emit('close')
    },
  },
}
</script>

<style></style>
